import { render, staticRenderFns } from "./ViolationRule.vue?vue&type=template&id=47b1289f&scoped=true"
import script from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViolationRule.vue?vue&type=style&index=0&id=47b1289f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1289f",
  null
  
)

export default component.exports